import { useState, useEffect, useCallback } from 'react';

export const useResponsiveItemsPerPage = (cardWidth = 230, gap = 20, desiredRows = 7) => {
  const [itemsPerPage, setItemsPerPage] = useState(21); // valor padrão
  const [itemsPerRow, setItemsPerRow] = useState(3); // valor padrão

  const calculateItemsPerPage = useCallback(() => {
    // Obtém a largura do container específico da lista de talentos
    const talentListContainer = document.querySelector('.talent-list-container');
    let containerWidth;

    if (talentListContainer) {
      // Se o container existe, usa sua largura real
      const containerRect = talentListContainer.getBoundingClientRect();
      containerWidth = containerRect.width - 72; // 72px para padding (36px de cada lado)
    } else {
      // Fallback: calcula baseado na largura da janela
      containerWidth = window.innerWidth - 200; // 200px para margens, sidebar, etc.
    }

    // Calcula quantos cards cabem por linha
    // cardWidth + gap = largura total de cada card incluindo espaçamento
    const cardsPerRow = Math.floor(containerWidth / (cardWidth + gap));

    // Garante pelo menos 1 card por linha
    const validCardsPerRow = Math.max(1, cardsPerRow);

    // Calcula itens por página baseado no número de linhas desejadas
    const calculatedItemsPerPage = validCardsPerRow * desiredRows;

    setItemsPerRow(validCardsPerRow);
    setItemsPerPage(calculatedItemsPerPage);

    return calculatedItemsPerPage;
  }, [cardWidth, gap, desiredRows]);

    useEffect(() => {
    // Pequeno delay para garantir que o DOM esteja renderizado
    const timer = setTimeout(() => {
      calculateItemsPerPage();
    }, 100);

    // Adiciona listener para redimensionamento da janela
    const handleResize = () => {
      calculateItemsPerPage();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', handleResize);
    };
  }, [calculateItemsPerPage]);

  return {
    itemsPerPage,
    itemsPerRow,
    recalculate: calculateItemsPerPage
  };
};
